;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "6UDcaSMTkF"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var _this = jQuery(this),
      list  = _this.find('.lh-blog-list');
  _this.find('.lh-item-title.active a');
  _this.find('.lh-item-title a').click(function(){
    var __this = $(this);
    if(!__this.hasClass('active')){
      __this.parent().addClass('active').siblings('.active').removeClass('active');
      setActiveCate(__this);
    }

  })
  function setActiveCate($this) {
    var target = $this.data('value'),
        e_target = _this.find('.lh-item-blog[data-handle="'+target+'"]');
    if(e_target){
      list.css('transform','translateX(-'+(e_target.index()*100)+'%)');
    }
  }
 };						cb.bind($('section[data-section-id="6UDcaSMTkF"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="6UDcaSMTkF"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDE5/NTc0ODY0ODc5/First_release/pages/Cowi_Blog/blog/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "lrx3x65i4qb"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var _this = jQuery(this),
      list  = _this.find('.lh-blog-list');
  _this.find('.lh-item-title.active a');
  _this.find('.lh-item-title a').click(function(){
    var __this = $(this);
    if(!__this.hasClass('active')){
      __this.parent().addClass('active').siblings('.active').removeClass('active');
      setActiveCate(__this);
    }

  })
  function setActiveCate($this) {
    var target = $this.data('value'),
        e_target = _this.find('.lh-item-blog[data-handle="'+target+'"]');
    if(e_target){
      list.css('transform','translateX(-'+(e_target.index()*100)+'%)');
    }
  }
 };						cb.bind($('section[data-section-id="lrx3x65i4qb"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="lrx3x65i4qb"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDE5/NTc0ODY0ODc5/First_release/pages/Cowi_Blog/blog/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');